import { useIdleTimer } from "react-idle-timer";

const useIdleTimeout = ({ onPrompt, idleTime = 1, ...props }) => {
  const idleTimeout = 1000 * 60 * idleTime;
  const idleTimer = useIdleTimer({
    timeout: idleTimeout,
    promptBeforeIdle: 1000 * 60,
    onPrompt: onPrompt,
    throttle: 500,
    ...props,
  });
  return idleTimer;
};
export default useIdleTimeout;
